export default __webpack_public_path__ + "static/terms-and-policies-generator-1-d76e8f6dfc98845cde731a10b4a5d870.png";